import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import Status from '../../../../UI/status/Status'
import ChangeStatusBillForm from './ChangeStatusBillForm'

const ChangeStatusBillButton = ({ supplyBill, status }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <button
            onClick={e => setOpen(true)}
        >
            <Status 
                status={supplyBill.status} 
            />
        </button>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Зміна статусу рахунку'}
            disableClickOutside={true}
            content={
                <ChangeStatusBillForm
                    supplyBillBd={supplyBill}
                    // userBd={user}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeStatusBillButton